<template>
  <div class="app-main-content" type="primary">
    <div class="grid-view">
      <div class="main-content">
        <div>
          <el-button size="mini" type="primary" @click="toQuery">{{ $t('CargoMsg.Cargo_Query') }}</el-button>
          <el-button size="mini" type="primary" @click="toAddAirPortRequirement">{{ $t('CargoMsg.Cargo_NewTo') }}</el-button>
          <el-button size="mini" type="primary" @click="toUpdateAirPortRequirement">{{ $t('CargoMsg.Cargo_EditTo') }}</el-button>
          <el-button size="mini" type="danger" @click="toBatchDelAirPortRequirement">{{ $t('CargoMsg.Cargo_Delete') }}</el-button>
          <cargo-grid-state-btn :grid-params="gridParams" config-module="101340" />
        </div>
        <div>
          <el-form :inline="true" label-width="100px" label-position="left" @submit.native.prevent>
            <div class="el-form-item-wrapper">
              <el-form-item :label="$t('SeaExport.LoadingPort')">
                <cargo-advance-select
                  filterable
                  :select-type="selectTypeNames.basic_data_Airport"
                  callback-method-type="value"
                  :default-value="searchConditions.loadingPortCode"
                  style="width:205px;"
                  :callback-params="{key:'loadingPortCode'}"
                  @parentCallBack="getValueSearchFromChild"
                />
              </el-form-item>
              <el-form-item :label="$t('SeaExport.PortOfDestination')">
                <cargo-advance-select
                  filterable
                  :select-type="selectTypeNames.basic_data_Airport"
                  callback-method-type="value"
                  :default-value="searchConditions.dischargingPortCode"
                  style="width:205px;"
                  :callback-params="{key:'dischargingPortCode'}"
                  @parentCallBack="getValueSearchFromChild"
                />
              </el-form-item>
              <el-form-item :label="$t('SeaExport.CargoType')">
                <cargo-advance-select
                  filterable
                  :select-type="selectTypeNames.basic_data_CargoType"
                  callback-method-type="value"
                  :default-value="searchConditions.cargoType"
                  style="width:205px;"
                  :callback-params="{key:'cargoType'}"
                  @parentCallBack="getValueSearchFromChild"
                />
              </el-form-item>
            </div>
          </el-form>
        </div>
        <div>
          <el-form :inline="true" label-width="100px" label-position="left" @submit.native.prevent>
            <div class="el-form-item-wrapper">
              <el-form-item :label="$t('SeaExport.AirlineCompany')">
                <cargo-advance-select
                  filterable
                  :select-type="selectTypeNames.basic_data_Company"
                  :method-params="{airCmp:true}"
                  callback-method-type="value"
                  :default-value="searchConditions.carrierId == 0 ? '': searchConditions.carrierId"
                  style="width:205px;"
                  :callback-params="{key:'carrierId'}"
                  @parentCallBack="getValueSearchFromChild"
                />
              </el-form-item>
              <el-form-item :label="$t('SeaExport.DestinationAgent')">
                <cargo-advance-select
                  filterable
                  :select-type="selectTypeNames.basic_data_Company"
                  callback-method-type="value"
                  :default-value="searchConditions.destinationAgent == 0 ? '': searchConditions.destinationAgent"
                  style="width:205px;"
                  :method-params="{overseaAgent:true}"
                  :callback-params="{key:'destinationAgent'}"
                  @parentCallBack="getValueSearchFromChild"
                />
              </el-form-item>
            </div>
          </el-form>
        </div>
        <div class="section grid-wrapper">
          <cargo-ag-grid
            config-module="101340"
            :grid-params.sync="gridParams"
            :grid-options="gridOptions"
            :column-defs="columnDefs"
            :row-data="rowData"
          />
        </div>
        <div class="pagination-wrapper">
          <cargo-pagination
            v-show="searchConditions.total>0"
            :config-module="'19198'"
            :total="searchConditions.total"
            :page.sync="searchConditions.pageNum"
            :limit.sync="searchConditions.pageSize"
            @pagination="fetchAirPortRequirement"
          />
        </div>
      </div>
    </div>
    <el-dialog
      v-if="isShowingAirportRequirementForm"
      v-el-drag-dialog
      custom-class=""
      :visible.sync="isShowingAirportRequirementForm"
      :title="formTitle"
      width="1000px"
      :close-on-click-modal="false"
      @close="cancel"
    >
      <div class="app-main-inner-row" style="padding-bottom: 10px;">
        <el-form :model="airPortRequirement" inline label-width="110px" label-position="left">
          <div class="el-form-item-wrapper">
            <el-form-item :label="$t('CargoMsg.Cargo_DisplayRules')">
              <template>
                <el-checkbox v-model="airPortRequirement.mawb">MAWB</el-checkbox>
                <el-checkbox v-model="airPortRequirement.hawb">HAWB</el-checkbox>
              </template>
            </el-form-item>
          </div>
          <div class="el-form-item-wrapper" style="padding-top: 10px;">
            <el-form-item :label="$t('SeaExport.LoadingPort')">
              <cargo-advance-select
                filterable
                :select-type="selectTypeNames.basic_data_Airport"
                callback-method-type="value"
                :default-multiple-value="airPortRequirement.loadingPortCodeArray"
                style="width:300px;"
                :callback-params="{}"
                multiple
                @parentCallBack="item=>airPortRequirement.loadingPortCodeArray=item.value"
              />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.PortOfDestination')">
              <cargo-advance-select
                filterable
                :select-type="selectTypeNames.basic_data_Airport"
                callback-method-type="value"
                :default-multiple-value="airPortRequirement.dischargingPortCodeArray"
                style="width:300px;"
                :callback-params="{}"
                multiple
                @parentCallBack="item=>airPortRequirement.dischargingPortCodeArray=item.value"
              />
            </el-form-item>
          </div>
          <div class="el-form-item-wrapper" style="padding-top: 10px;">
            <el-form-item :label="$t('SeaExport.PlaceOfDelivery')">
              <cargo-advance-select
                filterable
                :select-type="selectTypeNames.basic_data_Airport"
                callback-method-type="value"
                :default-multiple-value="airPortRequirement.destinationPortCodeArray"
                style="width:300px;"
                :callback-params="{}"
                multiple
                @parentCallBack="item=>airPortRequirement.destinationPortCodeArray=item.value"
              />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.Airline')">
              <cargo-advance-select
                filterable
                :select-type="selectTypeNames.basic_data_Region"
                :default-multiple-value="airPortRequirement.regionCodeArray"
                style="width:300px;"
                :callback-params="{}"
                multiple
                @parentCallBack="item=>airPortRequirement.regionCodeArray=item.value"
              />
            </el-form-item>
          </div>
          <div class="el-form-item-wrapper" style="padding-top: 10px;">
            <el-form-item :label="$t('SeaExport.AirlineCompany')">
              <cargo-advance-select
                filterable
                :select-type="selectTypeNames.basic_data_Company"
                :method-params="{airCmp:true}"
                callback-method-type="value"
                :default-value="airPortRequirement.carrierId == 0 ? '': airPortRequirement.carrierId"
                style="width:300px;"
                :callback-params="{key:'carrierId'}"
                @parentCallBack="getValueFromChild"
              />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.DestinationAgent')">
              <cargo-advance-select
                :key="1"
                filterable
                :select-type="selectTypeNames.basic_data_Company"
                callback-method-type="value"
                :default-value="airPortRequirement.destinationAgent == 0 ? '': airPortRequirement.destinationAgent"
                style="width:300px;"
                :method-params="{overseaAgent:true}"
                :callback-params="{key:'destinationAgent'}"
                @parentCallBack="getValueFromChild"
              />
            </el-form-item>
          </div>
          <div class="el-form-item-wrapper" style="padding-top: 10px;">
            <el-form-item :label="$t('SeaExport.CargoType')">
              <cargo-advance-select
                filterable
                :select-type="selectTypeNames.basic_data_CargoType"
                callback-method-type="value"
                :default-value="airPortRequirement.cargoType"
                style="width:300px;"
                :callback-params="{key:'cargoType'}"
                @parentCallBack="getValueFromChild"
              />
            </el-form-item>
          </div>
          <div class="el-form-item-wrapper" style="padding-top: 10px;">
            <el-form-item :label="$t('SeaExport.OperationRequirements')">
              <el-input
                v-model="airPortRequirement.operationRequirements"
                type="textarea"
                :rows="5"
                :placeholder="$t('Message.PleaseEnterTheContent')"
                style="width: 730px"
              />
            </el-form-item>
          </div>
          <div v-show="showCloudFile" class="el-form-item-wrapper" style="padding-top: 10px;">
            <el-form-item :label="$t('queryJob.AttachmentDescription')">
              <svg-icon icon-class="yibiao-tijiao" @click="appendixDescription" />
            </el-form-item>
          </div>
        </el-form>
      </div>
      <div slot="footer">
        <el-button type="primary" size="mini" @click="submitAirPortRequirement">{{ $t('CargoMsg.Cargo_ConfirmR') }}</el-button>
        <el-button size="mini" @click="isShowingAirportRequirementForm = false">{{ $t('CargoMsg.Cargo_Cancel') }}</el-button>
      </div>
    </el-dialog>
    <cargo-cloud-file-upload
      :visible.sync="cloudFile.visible"
      :job="cloudFile.job"
      :lob="cloudFile.lob"
      :show-all="cloudFile.showAll"
      @uploadDone="onUploadDone"
    />
  </div>
</template>

<script>
import URL from '@/api/urlTranslator'
import cargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect'
import { getToken } from '@/utils/auth'
import { getLoading } from '@/utils/utilBaseElement'
import {
  queryAirPortRequirementList,
  addAirPortRequirement,
  updateAirPortRequirement,
  batchDelAirPortRequirement
} from '@/api/airportRequirement'
import { getGridSelectedIds, getGridSelected } from '@/utils/agGrid'
import { DocumentManage } from '@/utils/commonUtil'
import cargoCloudFileUpload from '@/components/Cargo/Common/cargoCloudFileUpload'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'

export default {
  name: 'AirPortRequirement',
  components: { cargoAdvanceSelect, cargoCloudFileUpload },
  data() {
    return {
      selectTypeNames: TYPE_NAMES,
      loading: null,
      currentSessionId: getToken(),
      isShowingAirportRequirementForm: false,
      formTitle: '',
      searchConditions: {
        loadingPortCode: '',
        dischargingPortCode: '',
        destinationPortCode: '',
        region: '',
        carrierId: 0,
        destinationAgent: 0,
        freightTerm: '',
        cargoType: '',
        mawb: false,
        hawb: false,
        total: 0,
        pageNum: 1
      },
      gridOptions: {
        rowSelection: 'multiple',
        suppressCellSelection: true,
        context: {
          componentParent: this
        }
      },
      gridParams: {},
      gridApi: {},
      columnDefs: [
        {
          headerName: '', checkboxSelection: true,
          sortable: false, suppressMenu: true, suppressSizeToFit: true, resizable: false,
          headerCheckboxSelection: true
        },
        {
          headerName: this.$t('SeaExport.LoadingPort'),
          field: 'loadingPortEnglishName',
          width: 250,
          cellRendererFramework: 'CargoGridShowBigContent'
        },
        {
          headerName: this.$t('SeaExport.PortOfDestination'),
          field: 'dischargingPortEnglishName',
          width: 250,
          cellRendererFramework: 'CargoGridShowBigContent'
        },
        {
          headerName: this.$t('SeaExport.PlaceOfDelivery'),
          field: 'destinationPortEnglishName',
          width: 250,
          cellRendererFramework: 'CargoGridShowBigContent'
        },
        {
          headerName: this.$t('SeaExport.AirlineCompany'),
          field: 'carrierChineseName',
          width: 250,
          cellRendererFramework: 'CargoGridShowBigContent'
        },
        {
          headerName: this.$t('SeaExport.Airline'),
          field: 'regionEnglishName',
          width: 300,
          cellRendererFramework: 'CargoGridShowBigContent'
        },
        {
          headerName: this.$t('SeaExport.CargoType'),
          field: 'cargoTypeChineseName',
          width: 150,
          cellRendererFramework: 'CargoGridShowBigContent'
        },
        {
          headerName: this.$t('SeaExport.DestinationAgent'),
          field: 'destinationAgentChineseName',
          width: 250,
          cellRendererFramework: 'CargoGridShowBigContent'
        },
        {
          headerName: this.$t('SeaExport.OperationRequirements'),
          field: 'operationRequirements',
          width: 300,
          cellRendererFramework: 'CargoGridShowBigContent'
        },
        {
          headerName: this.$t('Message.IsItUsedForMAWB'),
          width: 150,
          cellRenderer: params => {
            const iconName = !params.data.mawb ? 'grid-icon-enabled' : 'grid-icon-disabled'
            const color = params.data.mawb ? '#67c23a' : '#e6a23c'
            return `<svg class="svg-icon" fill="${color}" aria-hidden="true" style="height:1.1em;width:1.1em;">
                <use xlink:href="#icon-${iconName}"></use>
              </svg>`
          }
        },
        {
          headerName: this.$t('Message.IsItUsedForHAWB'),
          width: 150,
          cellRenderer: params => {
            const iconName = !params.data.hawb ? 'grid-icon-enabled' : 'grid-icon-disabled'
            const color = params.data.hawb ? '#67c23a' : '#e6a23c'
            return `<svg class="svg-icon" fill="${color}" aria-hidden="true" style="height:1.1em;width:1.1em;">
                <use xlink:href="#icon-${iconName}"></use>
              </svg>`
          }
        },
        {
          headerName: this.$t('queryJob.AttachmentDescription'),
          field: '',
          width: 150,
          cellRenderer: params => {
            const uuid = params.data.uuid
            return `<span onclick="${this.documentManage.getPath('toShowFile')}('${uuid}')" style="color:#46a6ff">` + this.$t('CargoMsg.Cargo_ViewAttachments') + `</span>`
          }
        }
      ],
      sideBarDefs: { toolPanels: ['columns', 'filter'], visible: false },
      rowData: [],
      initAirPortRequirement: {
        uuid: '',
        tenantId: 0,
        version: 0,
        createdBy: 0,
        modifiedBy: 0,
        dateModified: new Date(),
        dateCreated: new Date(),
        loadingPortCodes: '',
        dischargingPortCodes: '',
        destinationPortCodes: '',
        regions: '',
        carrierId: 0,
        destinationAgent: 0,
        freightTerm: '',
        cargoType: '',
        mawb: false,
        hawb: false,
        operationRequirements: '',
        loadingPortCodeArray: [],
        dischargingPortCodeArray: [],
        destinationPortCodeArray: [],
        regionCodeArray: []
      },
      airPortRequirement: {
        uuid: '',
        tenantId: 0,
        version: 0,
        createdBy: 0,
        modifiedBy: 0,
        dateModified: '',
        dateCreated: '',
        loadingPortCodes: '',
        dischargingPortCodes: '',
        destinationPortCodes: '',
        regions: '',
        carrierId: 0,
        destinationAgent: 0,
        freightTerm: '',
        cargoType: '',
        mawb: false,
        hawb: false,
        operationRequirements: '',
        loadingPortCodeArray: [],
        dischargingPortCodeArray: [],
        destinationPortCodeArray: [],
        regionCodeArray: []
      },
      documentManage: new DocumentManage(),
      cloudFile: {
        visible: false,
        job: {
          uuid: ''
        },
        showAll: false,
        lob: 'OTHER'
      },
      showCloudFile: false
    }
  },
  computed: {
    url() {
      return URL
    }
  },
  beforeMount() {
    this.fetchAirPortRequirement()
  },
  created() {
    this.documentManage.set('toShowFile', this.toShow)
  },
  methods: {
    toShow(uuid) {
      this.cloudFile.showAll = true
      this.cloudFile.job.uuid = uuid
      this.cloudFile.visible = true
    },
    // 查询
    toQuery() {
      this.searchConditions.pageNum = 1
      this.fetchAirPortRequirement()
    },
    getValueSearchFromChild(obj) {
      this.searchConditions[obj.key] = obj.value
    },
    getValueFromChild(obj) {
      this.airPortRequirement[obj.key] = obj.value
    },
    // 新增
    toAddAirPortRequirement() {
      this.showCloudFile = false
      this.airPortRequirement = { ...this.initAirPortRequirement }
      this.isShowingAirportRequirementForm = true
      this.formTitle = this.$t('Message.AddPortRequirementsAirport')
    },
    // 编辑
    toUpdateAirPortRequirement() {
      const self = this
      const chooseRows = getGridSelected(self.gridOptions)
      if (chooseRows.length !== 1) {
        self.$message.warning(this.$t('Message.PleaseSelectARecordToEdit'))
        return
      }
      const airPortRequirement = { ...chooseRows[0] }
      self.showCloudFile = true
      // 装货港
      if (airPortRequirement.loadingPortCodes) {
        airPortRequirement.loadingPortCodeArray = airPortRequirement.loadingPortCodes.split(',')
      } else {
        airPortRequirement.loadingPortCodeArray = []
      }
      // 目的港
      if (airPortRequirement.dischargingPortCodes) {
        airPortRequirement.dischargingPortCodeArray = airPortRequirement.dischargingPortCodes.split(',')
      } else {
        airPortRequirement.dischargingPortCodeArray = []
      }
      // 交货地
      if (airPortRequirement.destinationPortCodes) {
        airPortRequirement.destinationPortCodeArray = airPortRequirement.destinationPortCodes.split(',')
      } else {
        airPortRequirement.destinationPortCodeArray = []
      }
      // 航线
      if (airPortRequirement.regions) {
        airPortRequirement.regionCodeArray = airPortRequirement.regions.split(',')
      } else {
        airPortRequirement.regionCodeArray = []
      }
      self.airPortRequirement = { ...airPortRequirement }
      this.isShowingAirportRequirementForm = true
      this.formTitle = this.$t('Message.EditPortRequirementsAirport')
    },
    // 删除
    toBatchDelAirPortRequirement() {
      const self = this
      const chooseRows = getGridSelected(self.gridOptions)
      if (chooseRows.length === 0) {
        this.$message.warning(this.$t('Message.PleaseSelectARecordToDelete'))
        return
      }
      getGridSelectedIds(self.gridOptions, 'uuid').then(ids => {
        return this.$confirm(this.$t('Message.DeleteTheSelectedRecord'), this.$t('Message.Prompt'), {
          confirmButtonText: this.$t('CargoMsg.Cargo_Confirm'),
          cancelButtonText: this.$t('CargoMsg.Cargo_Cancel'),
          type: 'warning'
        }).then(() => {
          return batchDelAirPortRequirement(ids)
        }).catch(() => {
          return Promise.reject(this.$t('Message.DeletionCancelled'))
        })
      }).then(res => {
        if (res.ok) {
          this.$message({
            type: 'success',
            message: this.$t('Message.DeleteSuccessfully')
          })
        } else {
          this.$message({
            type: 'info',
            message: this.$t('Message.DeleteFailed')
          })
        }
        self.fetchAirPortRequirement()
      }).catch(() => {
      })
    },
    // 新增或者编辑确定按钮事件
    submitAirPortRequirement() {
      const airPortRequirement = this.airPortRequirement
      if (!airPortRequirement.mawb && !airPortRequirement.hawb) {
        this.$message.warning(this.$t('Message.DisplayRuleCannotBeEmpty'))
        return
      }
      if (airPortRequirement.operationRequirements === '' || airPortRequirement.operationRequirements === null || airPortRequirement.operationRequirements === 'undified') {
        this.$message.warning(this.$t('Message.OperationRequirementsCannotBeEmpty'))
        return
      }

      if (airPortRequirement.operationRequirements.length > 2048) {
        this.$message.warning(this.$t('Message.OperationRequirementsCannotBeGreaterThan'))
        return
      }

      if (airPortRequirement.loadingPortCodeArray.length > 0) {
        airPortRequirement.loadingPortCodes = airPortRequirement.loadingPortCodeArray.reduce((a, b) => a + ',' + b)
      } else {
        airPortRequirement.loadingPortCodes = ''
      }

      if (airPortRequirement.dischargingPortCodeArray.length > 0) {
        airPortRequirement.dischargingPortCodes = airPortRequirement.dischargingPortCodeArray.reduce((a, b) => a + ',' + b)
      } else {
        airPortRequirement.dischargingPortCodes = ''
      }

      if (airPortRequirement.destinationPortCodeArray.length > 0) {
        airPortRequirement.destinationPortCodes = airPortRequirement.destinationPortCodeArray.reduce((a, b) => a + ',' + b)
      } else {
        airPortRequirement.destinationPortCodes = ''
      }

      if (airPortRequirement.regionCodeArray.length > 0) {
        airPortRequirement.regions = airPortRequirement.regionCodeArray.reduce((a, b) => a + ',' + b)
      } else {
        airPortRequirement.regions = ''
      }

      if (airPortRequirement.uuid === '' || airPortRequirement.uuid === null || airPortRequirement.uuid === 'undified') {
        return addAirPortRequirement(this.airPortRequirement).then(res => {
          this.isShowingAirportRequirementForm = false
          this.airPortRequirement = { ...this.initAirPortRequirement }
          this.$message({ message: this.$t('Message.NewPortRequestSucceeded'), type: 'success' })
          this.fetchAirPortRequirement()
        })
      } else {
        return updateAirPortRequirement(airPortRequirement).then(res => {
          this.isShowingAirportRequirementForm = false
          this.airPortRequirement = { ...this.initAirPortRequirement }
          this.$message({ message: this.$t('Message.EditPortRequestSucceeded'), type: 'success' })
          this.fetchAirPortRequirement()
        })
      }
    },
    fetchAirPortRequirement() {
      this.loading = getLoading()
      queryAirPortRequirementList(this.searchConditions).then(res => {
        this.searchConditions.total = Number(res.data.total)
        this.rowData = res.data.list
      }).finally(() => {
        this.loading.close()
      })
    },
    onUploadDone() {

    },
    // 附件说明
    appendixDescription() {
      this.cloudFile.job.uuid = this.airPortRequirement.uuid
      this.cloudFile.showAll = true
      this.cloudFile.visible = true
    },
    cancel() {
      this.airPortRequirement = { ...this.initAirPortRequirement }
    }
  }
}
</script>

<style scoped>

</style>
